const CHAT_URL =
  window.location.hostname ===
  "localhost"
    ? "http://127.0.0.1:5001/gofoton-55796/us-central1/chat"
    : "https://us-central1-gofoton-55796.cloudfunctions.net/chat";

export async function askOpenAI({
  messages,
  pagePath,
  visitorId,
  sessionId,
  lastPartNumber,
  onStatus,
}) {
  const response =
    await fetch(
      CHAT_URL,
      {
        method: "POST",

        headers: {
          "Content-Type":
            "application/json",
        },

        body:
          JSON.stringify({
            messages,
            pagePath,
            visitorId,
            sessionId,
            lastPartNumber,
            stream: true,
          }),
      }
    );

  if (!response.ok) {
    const text =
      await response.text();

    let data = {};

    try {
      data = text
        ? JSON.parse(text)
        : {};
    } catch {
      data = {
        error: text,
      };
    }

    throw new Error(
      data.error ||
        `Pluma request failed (${response.status}).`
    );
  }

  const contentType =
    response.headers.get(
      "content-type"
    ) || "";

  /*
    Fallback in case the hosting
    layer returns ordinary JSON.
  */

  if (
    !response.body ||
    !contentType.includes(
      "application/x-ndjson"
    )
  ) {
    const text =
      await response.text();

    const data =
      text
        ? JSON.parse(text)
        : {};

    return data;
  }

  const reader =
    response.body.getReader();

  const decoder =
    new TextDecoder();

  let buffer = "";
  let finalResult = null;

  const processLine = (
    line
  ) => {
    if (!line.trim()) {
      return;
    }

    const event =
      JSON.parse(line);

    if (
      event.type ===
      "status"
    ) {
      onStatus?.({
        status:
          event.status ||
          "",

        detail:
          event.detail ||
          "",
      });

      return;
    }

    if (
      event.type ===
      "result"
    ) {
      finalResult =
        event.data;

      return;
    }

    if (
      event.type ===
      "error"
    ) {
      throw new Error(
        event.error ||
          "Pluma could not complete the request."
      );
    }
  };

  while (true) {
    const {
      value,
      done,
    } =
      await reader.read();

    if (done) break;

    buffer +=
      decoder.decode(
        value,
        {
          stream: true,
        }
      );

    const lines =
      buffer.split("\n");

    buffer =
      lines.pop() || "";

    lines.forEach(
      processLine
    );
  }

  buffer +=
    decoder.decode();

  if (buffer.trim()) {
    processLine(buffer);
  }

  if (!finalResult) {
    throw new Error(
      "Pluma completed without returning a result."
    );
  }

  return finalResult;
}